import React, { useState } from 'react';
import CustomContainer from '../../components/CustomContainer';
import HouseOffersComponent from './result/HouseOffersComponent';
import ResultHeader from './result/ResultHeader';
import SearchHouse from '../../components/lakeview/searchHouse/SearchHouse';

const HouseOffersPage = (props) => {
  const [offersResult, setOffersResult] = useState();

  return (
    <>
      <CustomContainer
        subtitle={<ResultHeader offersResult={offersResult} />}
      >
        <SearchHouse
          title={'Wyszukaj domek'}
          setResult={setOffersResult} />
        <HouseOffersComponent
          offers={offersResult?.result} width={8} />
      </CustomContainer>
    </>
  );
};

export default HouseOffersPage;
